<template>
<div class="b-file-item">
  <a :href="img" target="_blank">
    <a-icon class="close" type="close" @click="closeHandler" />
    <img :src="img" alt="...">
  </a>
</div>
</template>

<script>
  import { Icon } from 'ant-design-vue'
  export default {
    name: "b-file-item",
    components: {
      [Icon.name]: Icon
    },
    props: {
      img: {
        type: String
      },
      index: {
        type: Number
      },
    },
    methods: {
      closeHandler (e) {
        this.$emit('close', this.index)
        e.preventDefault()
        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
.b-file-item {
  margin: 5px;
  width: 100px;
  height: 100px;
  position: relative;
  border: 1px solid $text-gray-ddd;
  img {
    display: block;
    width: 100%;
    height: 100%;
    // object-fit: none;
  }
  .close {
    position: absolute;
    top: 5px;
    right: 5px;
    color: $text-gray-ddd;
    font-size: 12px;
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
